'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasds';
var iconName = 'floppy-disk';
var width = 448;
var height = 512;
var aliases = [128190,128426,"save"];
var unicode = 'f0c7';
var svgPathData = ['M0 32l0 448 448 0 0-333.3-105.4-105.4-9.4-9.4-333.3 0zM96 96l224 0 0 128-224 0 0-128zM288 352a64 64 0 1 1 -128 0 64 64 0 1 1 128 0z', 'M160 352a64 64 0 1 1 128 0 64 64 0 1 1 -128 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faFloppyDisk = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;